import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  InputLabel,
  TextField,
  Slide,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TextInput from "../../../components/Form/TextInput";
import DateIn from "../../../components/Form/Date";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import SelectX from "../../../components/Form/SelectX";
import { ErrorMessage } from "@hookform/error-message";
import AddIcon from "@mui/icons-material/Add";
import CurrentDateInput from "../../../components/Form/CurrenDateInput";
import { Leads } from "../../../api/Endpoints/Leads";
import moment from "moment";

import {
  fetchAssignees,
  fetchProjects,
  fetchLeads,
  fetchStatus,
  fetchLeadSources,
  fetchCampaignTypes,
} from "../../../components/CommonFunctions/DropdownLists";
import LabelsList from "../../../components/CommonFunctions/LabelsList";
import ReactSelect from "react-select";
import { CampaignsAPI } from "../../../api/Endpoints/CampaignsAPI";
import { status } from "nprogress";
import WhatsappTemplates from ".";
import { WhatsappTemplatesAPI } from "../../../api/Endpoints/WhatsappTemplateAPI";
import DynamicParameters from "./elements/DynamiceParameters";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Create = (props) => {
  // const scheme = yup.object().shape({
  //     name: yup.string().required("campaign name is required"),

  // })

const phoneRegex = /^[0-9]{8,15}$/; // Adjust based on your valid phone format
  const schema = yup.object().shape({
  title: yup
    .string()
    .required("Template name is required")
    .matches(/^[a-z0-9_]+$/, "Only lowercase letters, numbers, and underscores are allowed"),

  template_content: yup
    .string()
    .required("Template content is required"),

button_text: yup
  .string()
  .test(
    "buttonTextRequiredIfLinkExists",
    "button text is required",
    function (value) {
      const { button_link } = this.parent;
      if (button_link && !value) return false;
      return true;
    }
  ),

button_link: yup
  .string()
  .test(
    "buttonLinkRequiredIfTextExists",
    "button link is required",
    function (value) {
      const { button_text } = this.parent;
      if (button_text && !value) return false;
      return true;
    }
  ),

  call_button_text: yup.lazy((_, { parent }) => {
    const number = parent.call_button_number;
    return (number && number.trim().length > 0)
      ? yup.string().required("phone text is required")
      : yup.string().notRequired();
  }),

  call_button_number: yup.lazy((_, { parent }) => {
    const text = parent.call_button_text;
    return (text && text.trim().length > 0)
      ? yup.string()
          .required("phone number is required")

      : yup.string().notRequired();
  })

});

  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    Controller,
    setValue,
    clearErrors,
    getValues,
    reset,
  } = useForm({
    mode: "all",
    resolver: yupResolver(schema),
  });

  const [open, setOpen] = React.useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [Loading, setLoading] = useState(false);
  const [statusLIst, setStatusList] = useState([]);
  const [selectedParams, setSelectedParams] = useState([]);
  const [customFiles, setCustomFiles] = useState(null)
  const { fetchLabels } = LabelsList();

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => {
      props.setModal && props.setModal(false);
    }, 200);
    props.setEditId(undefined);
    setValue("campaign_name", "");
    setValue("end_date", "");
    setValue("start_date", yup.date());
    setValue("total_budget", "");
    setValue("status", null);
    setValue("remarks", "");
    setValue('title', '');
    setCustomFiles(null);
    setValue('template_content', '');
    reset();
    clearErrors();
    
    
  };

  const handleClickOpen = () => {
    props.onNew();
  };
  //component variables
  const [formButtonStatus, setFormButtonStatus] = useState({
    label: "Submit",
    loading: false,
    disabled: false,
  });

  const exampleValues = {
    "{{NAME}}": "Test Name",
    "{{phone}}": "1234567890",
  };

  const onSubmit = (data) => {
    setFormButtonStatus({ ...formButtonStatus, loading: true });

    const formData = new FormData();

    formData.append(
      "name",
      data.title?.toLowerCase().replace(/\s+/g, "_")
    );
    formData.append("category", "MARKETING");
    formData.append("language", "en_US");

    formData.append("components[header_text]", data?.title);
    formData.append("components[body_text]", data?.template_content);
    const exampleText = Object.values(selectedParams)
      .map((param) => exampleValues[param] || "N/A") // Use "N/A" for missing values
      .join(", "); 

      
if(data.button_text&&data.button_link){
  formData.append("components[button_text]", data.button_text);
  formData.append("components[button_link]", data.button_link);
}
if(data.call_button_number&&data.call_button_text){
  const phone = data.call_button_number.startsWith('+91')
  ? data.call_button_number
  : `+91${data.call_button_number}`;

  formData.append("components[call_button_text]", data.call_button_text);
  formData.append("components[call_button_number]",phone);
}


    formData.append("components[body_example_text]", exampleText);


    if (customFiles && customFiles.type) {
      const file = customFiles;
     
       const maxSizeMB = 5;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;


    if (file.size > maxSizeBytes) {
    
      toast.error("File too large. Please upload a file smaller than 5MB.",{autoClose: 2000});
              setFormButtonStatus({
          label: "Submit",
          loading: false,
          disabled: false,
        });
      return;
    }

      const isImage = file.type.startsWith("image/");
      const fileType = isImage ? "image" : "document";
      const fileKey = isImage ? "image" : "document";
      formData.append("components[header_type]", fileType);
      formData.append(fileKey, file);
    } else {
      console.log("No file selected");
    }
    


    let action;
    if (props.editId > 0) {
      action = WhatsappTemplatesAPI.add(formData);
    } else {
      action = WhatsappTemplatesAPI.add(formData);
    }

    action
      .then(async (response) => {
        if (response.data.message === "Updated") {
          toast.success(" Successfully Updated!", { autoClose: 1000 });
        } else {
          try {
            toast.success("Template Successfully Saved!", { autoClose: 1000 });
          } catch (error) {
            console.error("Error:", error);
          }
        }

        setFormButtonStatus({
          label: "Submit",
          loading: false,
          disabled: false,
        });
        handleClose();
        props.onUpdate();

      })
      
      .catch((error) => {
        
        const apiError = error?.data?.error?.error?.error_user_msg;
     
      
        const userMessage =
          apiError?.error_user_msg ||
          apiError?.message ||
          "Internal Server Error, please try again later!";
      
        toast.error(userMessage, {
          autoClose: 1000,
        });
      
        setFormButtonStatus({
          label: "Submit",
          loading: false,
          disabled: false,
        });
      });
      
  };

  async function getIP(retryCount = 0) {
    try {
      const response = await fetch("https://api.ipify.org/?format=json");
      const data = await response.json();
      setIpAddress(data.ip);
    } catch (err) {
      console.log(err);
      if (retryCount < 2) {
        retryCount++;
        getIP(retryCount);
      } else {
        console.log("Something went wrong. Failed to retrieve IP address.");
      }
    }
  }

  const fetchLeadDetails = (retryCount = 2) => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const fetchCampaignTypes = await CampaignsAPI.getCampaignTypes();
        CampaignsAPI.getDetails({ id: props.editId })
          .then((response) => {
            if (response.data.campaign) {
              const campaign = response.data.campaign;
              setValue("campaign_name", campaign.name);
              setValue("start_date", campaign.start_date);
              setValue("end_date", campaign.end_date);
              setValue("total_budget", campaign.total_budget);
              setValue("is_auto_added", campaign.is_auto_added);
              setValue("remarks", campaign.description);
              if (campaign.status === 1) {
                setValue("status", { id: 1, name: "ACTIVE" });
              } else {
                setValue("status", { id: 0, name: "INACTIVE" });
              }
            }
            let campaign_id = fetchCampaignTypes.data?.campaign_types;

            const foundCampaignType = campaign_id.find(
              (campaignType) =>
                campaignType.id === response.data?.campaign?.campaign_type_id
            );
            if (foundCampaignType) {
              setValue("campaign_type", foundCampaignType);
            } else {
              console.log("Campaign type not found for ID:");
            }

            setLoading(false);
          })
          .catch((err) => {
            console.error(err.message);
          });
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setLoading(false);
      }
    };

    fetchData();
  };

  useEffect(() => {
    if (parseInt(props.editId) > 0) {
      fetchLeadDetails();
      setOpen(true);
    } else if (Number(props.editId) === 0) {
      setOpen(true);
    } else {
      return;
    }
  }, [props.editId]);

  useEffect(() => {
    getIP();
  }, []);


  const DropdownLists=[
    {
       
      id: 0,
      type: "Text",
    },
      {id: 1,
      type: "Phone",
    },
   ]



  return (
    <div>
      {!props.disableCtnBtn && (
        <Button
          class="create-btn2"
          variant="contained"
          onClick={handleClickOpen}
        >
          {props.icon ? (
            <AddIcon
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            />
          ) : (
            "Create Template"
          )}
        </Button>
      )}
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            width: "50%",
            height: "100%",
            position: "fixed",
            right: 0,
            top: 0,
            bottom: 0,
            m: 0,
            p: 0,
            borderRadius: 0,
            maxHeight: "100%",
          },
        }}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {Loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "30vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          open && (
            <div class="create-frm">
              <DialogTitle class="form-title">
                <Button onClick={handleClose}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                      d="M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z"
                      fill="rgba(0,0,0,1)"
                    ></path>
                  </svg>
                </Button>
                {parseInt(props.editId) > 0
                  ? "Edit Template"
                  : "Create Template"}
              </DialogTitle>

              <DialogContent class="right-form" sx={{ mt: 2 }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <ErrorMessage
                    errors={errors}
                    name="multipleErrorInput"
                    render={({ messages }) =>
                      messages &&
                      Object.entries(messages).map(([type, message]) => (
                        <p key={type}>{message}</p>
                      ))
                    }
                  />
                  <Grid container spacing={2} sx={{ display: "flex" }}>
                    <Grid sx={{ p: 1 }} item xs={12} sm={12}>
                      <TextInput
                        control={control}
                        placeholder="e.g., example_template"
                        {...register("title", { required: true })}
                        label="Title"
                        value={watch("title")}
                      />
                    </Grid>
                  </Grid>


                  <Grid sx={{ mt: 2 }} item xs={12}>
                    <DynamicParameters
                      watch={watch}
                      register={register}
                      errors={errors}
                      setSelectedParams={setSelectedParams}
                      setCustomFiles={setCustomFiles}
                      customFiles={customFiles}
                    />
                  </Grid>

<Box sx={{ display: "flex", alignItems: "center", mt: 2, gap: 2 }}>
  <Typography sx={{ whiteSpace: "nowrap" }}>
    Additional Field:
  </Typography>

  <Box sx={{ minWidth: 150, flex: 1 }}>
    <ReactSelect
      options={DropdownLists}
      getOptionLabel={(option) => option.type}
      getOptionValue={(option) => option.id}
      value={watch('field_type')}
      name="field_type"
      styles={{
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
      }}
      onChange={(selectedOption) => {
        setValue('field_type', selectedOption);
      }}
    />
  </Box>
</Box>
{watch('field_type') && watch('field_type').type === 'Text' && (
  <Grid container spacing={2} sx={{ display: "flex" }} mt={3}>
                    <Grid sx={{ p: 1 }} item xs={6} sm={6}>
                      <TextInput
                        control={control}
                        placeholder="e.g., Visit Now"
                        {...register("button_text")}
                        label="Button Text"
                        
                        value={watch("button_text")}
                        helpertext={errors.button_text?.message}
                      />
                    </Grid>
                        <Grid sx={{ p: 1 }} item xs={6} sm={6}>
                      <TextInput
                        control={control}
                        placeholder="e.g., https://desaihomes.in/"
                        {...register("button_link",)}
                        label="Button Link"
                        value={watch("button_link")}
                        helpertext={errors.button_link?.message}
                      />
                    </Grid>
                  </Grid>
)}
{watch('field_type') && watch('field_type').type === 'Phone' && (
  <Grid container spacing={2} sx={{ display: "flex" }} mt={3}>
                    <Grid sx={{ p: 1 }} item xs={6} sm={6}>
                      <TextInput
                        control={control}
                        placeholder="e.g., Call Now"
                        {...register("call_button_text")}
                        label="Phone Text"
                        
                        value={watch("call_button_text")}
                        helpertext={errors.call_button_text?.message}
                      />
                    </Grid>
                        <Grid sx={{ p: 1 }} item xs={6} sm={6}>
                      <TextInput
                        control={control}
                        placeholder="e.g., +919745000000"
                        {...register("call_button_number",)}
                        label="Phone Number"
                        value={watch("call_button_number")}
                        helpertext={errors.call_button_number?.message}
                      />
                    </Grid>
                  </Grid>
)}
     {/*  */}

                  <Grid sx={{ p: 1 }} item xs={12} mt={2}>
                    <LoadingButton
                      class="main-btn2"
                      loading={formButtonStatus.loading}
                      variant="outlined"
                      type="submit"
                    >
                      {formButtonStatus.label}
                    </LoadingButton>
                  </Grid>
                </form>
              </DialogContent>
            </div>
          )
        )}
      </Dialog>
    </div>
  );
};

export default Create;
